// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /invite/user-search.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeInviteUserSearchBody,
  typeInviteUserSearchOutput200,
} from "../../sdk/invite/postInviteUserSearch";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildInviteUserSearchQueryKey(
  payload: typeInviteUserSearchBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  queryKeySegments.push(`query:${JSON.stringify(payload.query)}`);
  return ["post:invite:inviteUserSearch", "svc:pool-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeInviteUserSearchOutput200,
    unknown,
    typeInviteUserSearchOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useInviteUserSearch(
  payload: typeInviteUserSearchBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildInviteUserSearchQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postInviteUserSearch(payload),
    ...resolvedOptions,
  });
}
